<template>
  <div class="index">欢迎</div>
</template>

<script>
export default {
  name: 'index',
  props: {
    msg: String
  },
  data() {
    return {
    };
  },
  mounted () {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .index{
    text-align: center;
    padding-top: 10rem;
    font-size: 2rem;
  }
</style>
